/* eslint-disable */
export default {
  to: 'To:',
  enterNameOrPhoneNumber: 'Enter number',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
